import { render, staticRenderFns } from "./top-theme.vue?vue&type=template&id=34518f89&scoped=true&"
import script from "./top-theme.vue?vue&type=script&lang=js&"
export * from "./top-theme.vue?vue&type=script&lang=js&"
import style0 from "./top-theme.vue?vue&type=style&index=0&id=34518f89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34518f89",
  null
  
)

export default component.exports